/* ============================================================
   GOB — header predictive-search re-rank
   2026-08-25

   The header dropdown renders Shopify's predictive-search results in
   Shopify's own order, and that order is wrong for set-number queries.
   Nine "Display Wall-Mount for …" products carry 42083 / bugatti / chiron
   inside Shopify's search index even though no editable field on them
   contains those strings (residue from the batch being duplicated from the
   Bugatti mount). They therefore match every set number and occupy nine of
   the ten slots Shopify returns, pushing the real products down or off.

   Two things happen here, both client-side:

     1. Re-rank what came back. Title matches beat tag/SKU matches, and
        within a title match the order is light kit, then display mount,
        then LED nameplate. That is the order a visitor wants: the kit they
        came for, then the accessories for the same set.

     2. For a set-number query, fetch the same term with " display" appended
        and splice in any same-set products the first response could not fit.
        Shopify caps resources[limit] at 10 and silently ignores anything
        higher, so the second query is the only way to reach an LED nameplate
        that the polluted wall-mounts crowded out.

   The re-rank is stable inside each tier, so Shopify's own order survives
   wherever this has no opinion. It can promote a better match; it cannot
   invent one.
   ============================================================ */
(function () {
  'use strict';

  var BOX = '#predictive-search';
  var LIST = '.results--products ul';
  var TITLE = '.results-products__info span';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }
  /* a bare set number, with or without a range: 42083, 77242-77251 */
  function setNumber(q) {
    var t = String(q || '').trim();
    return /^[0-9]{4,7}([-\s][0-9]{4,7})?$/.test(t) ? t : null;
  }
  /* category, read from the title — product_type is blank on the mounts */
  function tier(title) {
    var t = String(title || '').toLowerCase();
    if (t.indexOf('light kit') > -1) return 0.6;
    if (t.indexOf('wall-mount') > -1 || t.indexOf('wall mount') > -1 || t.indexOf('display') > -1) return 0.4;
    if (t.indexOf('nameplate') > -1) return 0.2;
    return 0;
  }
  function score(title, q) {
    var t = norm(title), needle = norm(q);
    if (!needle) return 0;
    var tight = needle.replace(/ /g, '');
    var words = needle.split(' ').filter(Boolean);
    var s = 0;
    if (t.indexOf(needle) > -1 || t.replace(/ /g, '').indexOf(tight) > -1) s = 2;
    else if (words.length > 1 && words.every(function (w) { return t.indexOf(w) > -1; })) s = 1;
    return s ? s + tier(title) : 0;
  }

  /* ---- companion fetch, cached per query ---- */
  var cache = {};
  function companion(q) {
    if (cache[q]) return cache[q];
    var url = root() + 'search/suggest.json?q=' + encodeURIComponent(q + ' display') +
              '&resources[type]=product&resources[limit]=10' +
              '&resources[options][unavailable_products]=last';
    cache[q] = fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { return ((d.resources || {}).results || {}).products || []; })
      .catch(function () { return []; });
    return cache[q];
  }

  /* build one <li> in the theme's own shape by cloning a real one */
  function makeItem(model, p) {
    var li = model.cloneNode(true);
    var a = li.querySelector('a');
    if (a) a.setAttribute('href', p.url || '#');
    var span = li.querySelector(TITLE);
    if (span) span.textContent = p.title || '';
    var img = li.querySelector('img');
    var src = (p.featured_image && p.featured_image.url) || p.image || '';
    if (img) {
      if (src) {
        img.removeAttribute('srcset');
        img.removeAttribute('data-srcset');
        img.removeAttribute('sizes');
        img.setAttribute('src', src);
        img.setAttribute('alt', '');
      } else {
        var wrap = li.querySelector('.results-products__image');
        if (wrap) wrap.innerHTML = '';
      }
    }
    li.setAttribute('data-gob-added', '1');
    return li;
  }

  function reorder(ul, q) {
    var items = Array.prototype.slice.call(ul.children);
    if (items.length < 2) return items;
    var decorated = items.map(function (li, i) {
      var el = li.querySelector(TITLE);
      return { li: li, s: score(el ? el.textContent : '', q), i: i };
    });
    decorated.sort(function (a, b) { return (b.s - a.s) || (a.i - b.i); });
    var moved = decorated.some(function (d, n) { return d.i !== n; });
    if (moved) {
      var frag = document.createDocumentFragment();
      decorated.forEach(function (d) { frag.appendChild(d.li); });
      ul.appendChild(frag);
    }
    return decorated.map(function (d) { return d.li; });
  }

  function titlesIn(ul) {
    return Array.prototype.slice.call(ul.children).map(function (li) {
      var el = li.querySelector(TITLE);
      return norm(el ? el.textContent : '');
    });
  }

  function enrich(ul, q, cap) {
    var num = setNumber(q);
    if (!num) return;
    companion(q).then(function (products) {
      if (!document.body.contains(ul)) return;
      var tight = norm(num).replace(/ /g, '');
      var have = titlesIn(ul);
      var model = ul.querySelector('li');
      if (!model) return;
      var missing = products.filter(function (p) {
        var t = norm(p.title);
        if (t.replace(/ /g, '').indexOf(tight) === -1) return false;   /* same set only */
        return have.indexOf(t) === -1;
      });
      if (!missing.length) return;
      missing.forEach(function (p) { ul.appendChild(makeItem(model, p)); });
      var ordered = reorder(ul, q);
      /* keep the dropdown the length the theme asked for */
      ordered.slice(cap).forEach(function (li) {
        if (li.parentNode) li.parentNode.removeChild(li);
      });
    });
  }

  var lastKey = '';
  function apply() {
    var box = document.querySelector(BOX);
    if (!box) return;
    var ul = box.querySelector(LIST);
    if (!ul || !ul.children.length) { lastKey = ''; return; }
    var host = box.closest ? box.closest('predictive-search') : null;
    var input = host ? host.querySelector('input[name="q"]') : document.querySelector('predictive-search input[name="q"]');
    var q = input ? input.value.trim() : '';
    if (!q) return;
    var key = q + '|' + ul.children.length + '|' + titlesIn(ul).join('~');
    if (key === lastKey) return;
    lastKey = key;
    var cap = ul.children.length;
    reorder(ul, q);
    enrich(ul, q, cap);
  }

  function boot() {
    var host = document.querySelector('predictive-search');
    if (!host || host.dataset.gobRerank === '1') return;
    host.dataset.gobRerank = '1';
    var mo = new MutationObserver(function () { apply(); });
    mo.observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
